import { applyCommand } from "./applyCommand";
import { syncToInput } from "./syncToInput";

type Inputs = {
    editorElement: HTMLElement;
    inputElement: HTMLInputElement;
    toolbarElement: HTMLElement;
    formElement: HTMLFormElement;
    promptForUrl?: () => string | null;
};

// Wires a contenteditable region to a toolbar of [data-command] buttons and
// keeps the hidden input in sync so the composed HTML is submitted with the
// form. promptForUrl is injectable to keep link insertion testable.
export function initRichTextEditor({
    editorElement,
    inputElement,
    toolbarElement,
    formElement,
    promptForUrl = () => window.prompt("Link URL"),
}: Inputs): void {
    // The inline turbo:load script can re-run on repeat visits, calling this
    // more than once for the same editor. Bind listeners only once so toolbar
    // commands (e.g. inserting {recipient}) don't fire multiple times.
    if (editorElement.dataset.richTextInitialized === "true") return;
    editorElement.dataset.richTextInitialized = "true";

    toolbarElement.addEventListener("click", (event) => {
        const button = (event.target as HTMLElement).closest<HTMLElement>("[data-command]");
        if (!button) return;

        event.preventDefault();

        const command = button.dataset.command as string;
        let value = button.dataset.value;
        if (command === "createLink") {
            const url = promptForUrl();
            if (!url) return;
            value = url;
        }

        applyCommand({ editorElement, command, value });
        syncToInput({ editorElement, inputElement });
    });

    editorElement.addEventListener("input", () => {
        syncToInput({ editorElement, inputElement });
    });

    formElement.addEventListener("submit", () => {
        syncToInput({ editorElement, inputElement });
    });

    syncToInput({ editorElement, inputElement });
}
